import qs from 'qs';
import { network } from 'services/network';

export const createTag = ({ customerId, name, projectId }) => {
    const querystring = qs.stringify({ customerId, name, projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/createTag${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
